<template>
    <div class="navbar">
            <el-aside :width="isCollapse ? '64px' : '200px'">
                <!-- <div class="toggle-button" @click="toggleCollapse">|||</div> -->
                <!-- 侧边栏菜单区域 -->
                <el-menu
                    background-color="#333744"
                    text-color="#fff"
                    active-text-color="#409EFF"
                    :unique-opened="true"
                    :collapse="isCollapse"
                    :collapse-transition="false"
                    :router="true"
                    :default-active="this.$route.path"
                    >
                        <el-submenu :index="item.id + ''" v-for="item in getListData" :key="item.id">
                        <!-- 一级菜单的模版区域 -->
                        <template slot="title">
                            <!-- 图标 -->
                            <!-- <i class="el-icon-coordinate"></i> -->
                            <!-- 文本 -->
                          <i :class="item.icon"></i><span>{{ item.name }}</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item :index="'/' + subItem.path" v-for="subItem in item.children" :key="subItem.id">
                              <i :class="subItem.icon"></i>
                                {{subItem.name}}
                            </el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                </el-menu>
            </el-aside>
        </div>
</template>
<script>
    export default {
        name:"NavbarView",
        data(){
            return {
                isCollapse: false,            // 是否折叠
                getListData:[]
            }
        },
        created() {
            this.menuData()
        },
        methods:{
            menuData() {
              console.log('token---------',sessionStorage.getItem('token'))
                const param = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                    uid:sessionStorage.getItem('uid'),
                }
                let roles=JSON.parse(sessionStorage.getItem('roles'));
                let role_ids=[];
                console.log('roles',roles)
                for(var i=0;i<roles.length;i++){
                  console.log('id----',roles[i].id)
                    role_ids.push(roles[i].id);
                }
                param.role_id=role_ids.join(',');

                this.$axios.proxyModuleList(param).then(res=>{
                    if(res.code == 200){
                        // console.log(res);
                        this.getListData = res.data
                    }
                })
            },
          // 点击按钮，切换菜单的折叠与展开
          toggleCollapse () {
            this.isCollapse = !this.isCollapse
          },
        },


    }

</script>

<style scoped lang="less" scope>

    .el-header {
        background-color: #373d41;
        display: flex;
        justify-content: space-between;
        padding-left: 0;
        align-items: center;
        color: #fff;
        font-size: 20px;
    }
        .top_head_left {
            width: 500px;
            display: flex;
            align-items: center;
        }
            .top_head_left img {
            width: 50px;
            height: 50px;
        }
        .top_head_left span{
        margin-left: 15px;
        }
        .top_head_right {
        text-align: right;
        margin-right: 50px;
    }

    .margin_right {
        margin-right: 30px;
        }

    .el-header .el-button {
        background-color: transparent;
        border: none;
        color: #fff;
    }
    .el-header .el-button:hover {
        background-color: #337ab7;
    }

    .top_head_center {
        font-size: 16px;
        margin-left: 40px;
    }
    .el-submenu__title{
    text-align: left;
    }

    .toggle-button {
        background-color: #4a5064;
        font-size: 10px;
        line-height: 24px;
        color: #fff;
        text-align: center;
        letter-spacing: 0.2em;
        cursor: pointer;
    }
    ::v-deep.el-menu-item-group__title{
        padding: 0;
        line-height: normal;
        font-size: 12px;
        color: #909399;
    }
    /deep/.el-submenu.is-active .el-submenu__title{
        height: 45px!important;
        line-height: 45px!important;
    }
    /deep/.el-submenu .el-menu-item{
        height: 40px;
        line-height: 40px;
        padding-left: 25px!important;
    }
    /deep/.el-menu{border-right:none;}
</style>
